import { RFValue } from "react-native-responsive-fontsize";


export default {
  COLORS: {
    ALERT: "#ec1414",
    ICON: '#00544F', //COR DOS CADEADOS E DAS SETAS PARA O LADO
    ICON_HEADER_PURCHASE: "#2e2e2e", //COR DAS SETINHAS 
    BACKGROUND_HEADER: "none", //COR DE TODOS OS CABEÇALHOS
    //TELA CLICKCOURSE, PLANS e SIGNUP
    ICON_HEADER: "#2e2e2e",  //COR DA PALAVRA ESCOLHER COMPRA, CADASTRAR-SE E COMPLETAR PAGAMENTO e VOLTAR da EDITPROFILE
    //CORES GERAIS
    PRIMARY_900: "#00544F", //COR MAIS ESCURA DO CLIENTE = COR PRINCIPAL DOS DETALHES DO APP - CHECKBOX, FECHAR TERMOS DE USO, ETC 
    PRIMARY_800: "#F5BF85", //COR INTERMEDIÁRIA DO CLIENTE PARA INPUT LOGIN E ACTIVITY INDICATOR
    PRIMARY_700: "#E8BEBA", //COR MAIS CLARA DO CLIENTE = COR PRINCIPAL MAIS CLARA PARA INPUT LOGIN E ACTIVITY INDICATOR
    TEXT_BUTTON: "#FFFFFF", //USADA PARA O TEXTO DOS BOTÕES LOGIN, CLICKCOURSE, SIGNUP - COR DE FUNDO É A PRIMARY_900

    //CORES DO DRAWER
    DRAWER_SELECTED: "#00544F", //COR DRAWER CLICADO E DO TEXTO DO DRAWER

    //TELAS: LOGIN, CLICKCOURSE, SIGNUP E PLANS
    BACKGROUND_ABOUT: "#FFFFFF", //COR PARA A ABOUT, DRAWER, CLICK COURSE, PLANS, EDITPROFILE, LOGIN E CADASTRO
    TITLE_ABOUT: '#2e2e2e', //TAMANHOS EXTRABIG, BIG E STANDARD (usadas em páginas como dos termos de uso)
    TEXT_ABOUT: '#2e2e2e', //TAMANHOS MEDIUM, SMALL E EXTRASMALL

    //TELA TERMOS DE USO
    BACKGROUND_TERMS: "#FFFFFF", //COR PARA O FUNDO DOS TERMOS

    //PLANS
    S5_BACKGROUND: "#FFFFFF",
    S5_BACKGROUND_SELECTED: "#00544F", //COR DE FUNDO DO ITEM SELECIONADO DA FLATLIST MENSAL, TRI, ETC
    S5_BACKGROUND_NO_SELECTED: "transparent", //COR DE FUNDO DO ITEM NAO SELECIONADO DA FLATLIST MENSAL, TRI, ETC
    S5_TEXT_SELECTED: "#084D5D", //COR DO TEXTO DO ITEM SELECIONADO DA FLATLIST MENSAL, TRI, ETC
    S5_TEXT_NO_SELECTED: "white",
    
    //TELA MAIN
    ICON_HEADER_CLICKCLASS: "#17543E", //COR DO ÍCONE VOLTAR DA CLICKCLASS
    ICON_HEADER_MAIN: "#F5BF85", //COR DO ICONE DRAWER
    BACKGROUND_MAIN: "#F5BF85", //COR PARA A MAIN E CLICKCLASS
    TITLE_OVERPHOTO_MAIN: "#F5BF85", //USADA PARA O TÍTULO E SUBTÍTULO DA MAIN
    TITLE_MAIN: "#17543E", //USADA PARA PARA OS TAMANHOS EXTRABIG, BIG E STANDARD
    TEXT_MAIN: "#17543E", //USADA PARA PARA OS TAMANHOS MEDIUM, SMALL E EXTRASMALL

    //FOOTER TELA ABOUT E DRAWER
    BACKGROUND_FOOTER: "#ffffff", //COR DO RODAPÉ
    TEXT_FOOTER: "#2e2e2e", //USADA PARA O TEXTO DO RODAPÉ

    GRADIENT_MAIN: [
      "rgba(0,0,0,0.5)",
      "rgba(0,0,0,0.1)",
      "rgba(0,0,0,0.1)",
      "#F5BF85",
    ],

    //BOTÕES ARQUIVAR E PUBLICAR
    BACKGROUND_PUBLISH: "#00544F", //COR DO RODAPÉ
    BACKGROUND_ARCHIVE: "#F5BF85", //COR DO RODA
    TEXT_PUBLISH: "#FFFFFF", //USADA PARA O TEXTO DO RODAPÉ
    TEXT_ARCHIVE: "#2e2e2e", //USADA PARA O TEXTO DO RODAPÉ
  },

  FONTFAMILY: {
    BOLD: "text_Bold",
    MEDIUM: "text_Medium",
    REGULAR: "text_Regular",
    LIGHT: "text_Light",
    TITLE: "text_Title",
    SUBTITLE: "text_Subtitle",
    TEXTS: "text_Texts"
  },
  FONTSIZE: {
    EXTRABIG: RFValue(30, 980), //USADA 1X NA COURSES
    BIG: 26,
    STANDARD: 22,
    MEDIUM: 18,
    SMALL: 16,
    EXTRASMALL: 13,
  },
};